import { Label, Pivot, PivotItem } from "@fluentui/react";
import "./BetterPivot.scss";

export interface IBetterPivotProps {
  voices: { key: string; text: string; iconName?: string }[];
  onSelectedKey?: (key: string) => void;
}

const BetterPivot = (props: IBetterPivotProps) => {
  return (
    <div style={{ maxWidth: "100%", overflow: "auto", overflowY: "hidden" }}>
      <Pivot
        aria-label="Basic Pivot"
        onLinkClick={(item: PivotItem | undefined) => {
          if (item && props.onSelectedKey) {
            props.onSelectedKey((item as any).key.replace(".$", ""));
          }
        }}
      >
        {props.voices.map(
          (x: { key: string; text: string; iconName?: string }) => {
            return (
              <PivotItem
                key={x.key}
                itemIcon={x.iconName}
                headerText={x.text}
              ></PivotItem>
            );
          }
        )}
      </Pivot>
    </div>
  );
};

export default BetterPivot;
